import { call, put, fork, takeLatest } from 'redux-saga/effects';

import { navigateToIntervention } from 'actions/navigateActions';
import * as offerActions from 'actions/offerActions';
import { exportOffersFailure, exportOffersSuccess } from 'actions/offerActions';
import { restClient } from 'config/store/configureStore';
import * as types from 'constants/ActionTypes';
import { createNotification } from 'modules/toast-notifications/actions';

import OfferService from 'services/api/OfferService';
import { downloadFile } from 'services/Utils';

// GET SPECIFIC OFFER
function* fetchOfferWatcher() {
  yield takeLatest(types.FETCH_OFFER_REQUEST, fetchOffer);
}

function* fetchOffer(action) {
  try {
    const response = yield call(OfferService.getOffer, action.offerId, action.params);
    yield put(offerActions.fetchOfferSuccess(response.data));
  } catch (e) {
    yield put(offerActions.fetchOfferFailure(e));
  }
}

/* GET */
function* fetchOffersWatcher() {
  yield takeLatest(types.FETCH_OFFERS_REQUEST, fetchOffers);
}

function* fetchOffers(action) {
  try {
    const response = yield call(OfferService.getOffers, action.links, action.params);
    yield put(offerActions.fetchOffersSuccess(response.data.content, response.data.page, response.data.links));
  } catch (e) {
    yield put(offerActions.fetchOffersFailure(e));
  }
}

function* exportOffers({ payload }) {
  const { request } = payload;
  try {
    yield call(restClient.request, request);
    yield put(exportOffersSuccess());
    yield put(
      createNotification({
        type: 'success',
        message: {
          id: 'car_config.export_modal.export_success',
          defaultMessage: 'Export in progress. Please check your inbox in a few minutes.',
        },
      })
    );
  } catch (errorMessage) {
    yield put(exportOffersFailure(errorMessage));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'car_config.export_modal.export_error',
          defaultMessage: 'An error occurred during the export of the offers.',
        },
      })
    );
  }
}

function* exportOffersWatcher() {
  yield takeLatest(types.EXPORT_OFFERS_REQUEST, exportOffers);
}

function* postInterventionOffer({ payload }) {
  const { request } = payload;
  try {
    const { data: intervention } = yield call(restClient.request, request);
    yield put(offerActions.createInterventionOfferSuccess(intervention.id));
    yield call(navigateToIntervention, intervention.id, intervention.module);
  } catch (error) {
    yield put(offerActions.createInterventionOfferFailure(error));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'http.error.message',
          defaultMessage: 'Oops! Something went wrong.',
        },
      })
    );
  }
}

function* postInterventionOfferWatcher() {
  yield takeLatest(types.POST_INTERVENTION_OFFER, postInterventionOffer);
}

function* getPdfOfferSpecs({ payload, meta }) {
  const { request } = payload;
  const fileName = meta?.filename;

  try {
    const { data: file } = yield call(restClient.request, request);
    downloadFile(file, { fileName, type: 'application/pdf' });
    yield put(offerActions.getPdfOfferSpecsSuccess());
  } catch (error) {
    yield put(offerActions.getPdfOfferSpecsFailure(error));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'http.error.message',
          defaultMessage: 'Oops! Something went wrong.',
        },
      })
    );
  }
}

function* getPdfOfferSpecsWatcher() {
  yield takeLatest(types.FETCH_OFFER_SPECS_PDF_REQUEST, getPdfOfferSpecs);
}

const OfferSagas = [
  fork(fetchOfferWatcher),
  fork(fetchOffersWatcher),
  fork(postInterventionOfferWatcher),
  fork(exportOffersWatcher),
  fork(getPdfOfferSpecsWatcher),
];

export default OfferSagas;
